/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useEffect, useState} from "react"


interface IHtmlProps {
  htmlData: any
}

/**
 * Renders the HTML view content the selected report.
 * HTML sections are rendered dynamically based on the report's contents and format.
 */
const Html = (props: IHtmlProps) => {
  const [htmlData, setHtmlData] = useState<any>(props?.htmlData)

  useEffect(() => {
    setHtmlData(props?.htmlData)
  }, [props])
  
  return(
    <div style={{height: "100%", width: "100%", justifyContent: "center"}}>
      {Object.keys(htmlData)?.map((reportSection: string, idx: number) => 
        <div key={idx} dangerouslySetInnerHTML={{__html: htmlData?.[reportSection]}}/>
      )}
    </div>
  )
}

export default Html
